<template>
    <v-modal
        :name="modalName"
        :width="700"
        height="100%"
        close-button
    >
      <div class="search">
        <universal-search :filters="filters" @update:filters="updateFilters" :key="request?.id">
            <template #app-custom-action="{ app }">
                <v-button
                    type="primary"
                    :loading="app.universal_object_identifier === fulfillingAppUoid"
                    @click.native="fulfill(app)"
                >
                    {{ $t('SELECT') }}
                </v-button>
            </template>
        </universal-search>
      </div>
    </v-modal>
</template>

<script>
import VModal from '@/components/VModal.vue';
import UniversalSearch from '@/components/UniversalSearch/UniversalSearch.vue';
import VButton from '@/components/Button.vue';

export default {
  components: {
    VModal, UniversalSearch, VButton,
  },
  props: {
    request: Object,
  },
  data() {
    return {
      modalName: 'fulfillRequestFromUniversalSearch',
      fulfillingAppUoid: null,
      filters: {
        name: '',
      },
    };
  },
  methods: {
    async fulfill(app) {
      if (this.fulfillingAppUoid) {
        return;
      }

      this.fulfillingAppUoid = app.universal_object_identifier;
      try {
        const fulfilledRequest = await this.$api.setPublishRequestStatus({
          status: 'fulfilled',
          id: this.request.id,
          uoid: app.universal_object_identifier,
          type: 'ios',
        });
        this.$emit('fulfilled', fulfilledRequest);
        this.$modal.hide(this.modalName);
      } finally {
        this.fulfillingAppUoid = null;
      }
    },
    updateFilters(newFilters) {
      for (const filter in newFilters) {
        this.$set(this.filters, filter, newFilters[filter]);
      }
    },
  },
  watch: {
    request: {
      handler() {
        this.filters = {};
        this.$set(this.filters, 'name', this.request?.name || '');
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  padding-top: 10px;
}
</style>
